var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCapGrayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1780_18402)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1780_18402",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1780_18402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0093 14.1651C9.30094 14.1651 8.58427 13.9818 8.02591 13.6234L3.00924 10.3484C2.07591 9.74011 1.51758 8.71511 1.51758 7.59844C1.51758 6.48178 2.07591 5.45678 3.00924 4.84844L8.03424 1.58178C9.15094 0.856775 10.8926 0.856775 12.0009 1.59011L16.9926 4.86511C17.9176 5.47344 18.4759 6.49844 18.4759 7.60678C18.4759 8.71511 17.9176 9.74011 16.9926 10.3484L12.0009 13.6234C11.4426 13.9901 10.7259 14.1651 10.0093 14.1651ZM10.0093 2.29011C9.53427 2.29011 9.05927 2.39844 8.7176 2.63178L3.70091 5.89844C3.11758 6.28178 2.77591 6.89844 2.77591 7.59844C2.77591 8.29844 3.10924 8.91511 3.70091 9.29844L8.7176 12.5734C9.40927 13.0234 10.6259 13.0234 11.3176 12.5734L16.3093 9.29844C16.8926 8.91511 17.2259 8.29844 17.2259 7.59844C17.2259 6.89844 16.8926 6.28178 16.3093 5.89844L11.3176 2.62344C10.9676 2.40678 10.4926 2.29011 10.0093 2.29011Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 18.9568C9.63361 18.9568 9.25861 18.9068 8.95861 18.8068L6.30031 17.9234C5.04198 17.5068 4.05031 16.1318 4.05865 14.8068L4.06698 10.8984C4.06698 10.5568 4.35031 10.2734 4.69198 10.2734C5.03365 10.2734 5.31698 10.5568 5.31698 10.8984L5.30865 14.8068C5.30865 15.5901 5.95865 16.4901 6.70031 16.7401L9.35861 17.6234C9.69195 17.7318 10.3086 17.7318 10.6419 17.6234L13.3003 16.7401C14.0419 16.4901 14.6919 15.5901 14.6919 14.8151V10.9484C14.6919 10.6068 14.9753 10.3234 15.3169 10.3234C15.6586 10.3234 15.9419 10.6068 15.9419 10.9484V14.8151C15.9419 16.1401 14.9586 17.5068 13.7003 17.9318L11.0419 18.8151C10.7419 18.9068 10.3669 18.9568 10.0003 18.9568Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.834 13.125C17.4923 13.125 17.209 12.8417 17.209 12.5V7.5C17.209 7.15833 17.4923 6.875 17.834 6.875C18.1757 6.875 18.459 7.15833 18.459 7.5V12.5C18.459 12.8417 18.1757 13.125 17.834 13.125Z",
    fill: "#5A5A5A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1780_18402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapGrayIcon);
export default __webpack_public_path__ + "static/media/cap_gray_icon.142c52a590bb1ad8e47be97d6fee2b8c.svg";
export { ForwardRef as ReactComponent };